import { render, staticRenderFns } from "./AuthRoot.vue?vue&type=template&id=36876884"
import script from "./AuthRoot.vue?vue&type=script&lang=js"
export * from "./AuthRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports